// this function determines if an array or object is empty
const toC = (input: number) => {
  return input.toFixed(1);
};

export default toC;
